module.exports = __webpack_public_path__ + "media/assets/great-story-fad139cba2d938d51611f61e82274f9f.svg";